import DashboardApi from '@/api/DashboardApi'
import { getInitialMiddleLangInitial } from '@/api/BudgetProgressReport/getInitialMiddleLangInitial'
import { middleLangToQuery } from '@/api/BudgetProgressReport/MiddleLangToQuery'
import { bpChangeValid } from '@/api/BudgetProgressReport/BPChangeValid'
import { changeMiddleLang } from '@/api/BudgetProgressReport/ChangeMiddleLang'
import { mergeData } from '@/api/BudgetProgressReport/MergeDate'
import { getBPList } from '@/api/BudgetProgressReport/GetBPList'

class BudgetProgressReport {
  static async getInitialMiddleLangInitial({ advertiserId }) {
    return getInitialMiddleLangInitial({ advertiserId })
  }

  static middleLangToQuery({ middleLang }) {
    return middleLangToQuery({ middleLang })
  }

  static async getBPList({ advertiserId }) {
    return getBPList({ advertiserId })
  }

  static bpChangeValid({ middleLang, IOId, BPId }) {
    return bpChangeValid({ middleLang, IOId, BPId })
  }

  static changeMiddleLang({ middleLang, IOId, BPId }) {
    return changeMiddleLang({ middleLang, IOId, BPId })
  }

  static mergeData({ tableData, middleLang, BPList }) {
    return mergeData({ tableData, middleLang, BPList })
  }

  static async fetchIOProgress({
    advertiserId,
    // 以下 null の値は optional
    IOIds = null,
    BPIds = null,
    dimensionType, // 'daily' or 'total'
    period,
    format = null,
    pageNo = null,
    pageSize = null,
  }) {
    const res = await DashboardApi.fetchIOProgress({
      advertiserId,
      // 以下 null の値は optional
      IOIds,
      BPIds,
      dimensionType,
      period,
      format,
      pageNo,
      pageSize,
    })
    return res
  }
}

export default BudgetProgressReport
